import { useMemo } from 'react'
import { useAuth } from '../contexts/AuthContext'
import { useTenant } from '../contexts/TenantContext'

/** Tenant header label from the active tenant record (tenants.label). */
export function useTenantHeaderLabel(): string | null {
  const { isAuthenticated } = useAuth()
  const { currentTenant } = useTenant()

  // eslint-disable-next-line react-hooks/preserve-manual-memoization
  return useMemo(() => {
    if (!isAuthenticated || !currentTenant?.label?.trim()) {
      return null
    }
    return currentTenant.label.trim()
  }, [isAuthenticated, currentTenant?.label])
}
